import { combineReducers } from '@reduxjs/toolkit';
import { brandDraftReducer } from 'features/admin/brands/store/brandDraftSlice';
import { brandsApi } from 'features/admin/brands/store/brandsApiSlice';
import { adminDerivedNotificationsReducer } from 'features/admin/protocol-editor/store/adminDerivedNotificationsSlice';
import { adminNotificationTemplatesReducer } from 'features/admin/protocol-editor/store/adminNotificationTemplatesSlice';
import { adminProtocolEditorReducer } from 'features/admin/protocol-editor/store/adminProtocolEditorSlice';
import { adminStudyEditorFullExamplesApi } from 'features/admin/protocol-editor/store/adminStudyEditorFullExamplesApiSlice';
import { authReducer } from 'features/auth/store/authSlice';
import { devToolsReducer } from 'features/dev-tools/store/devToolsSlice';
import { dynamicTranslationReducer } from 'features/i18n/DynamicTranslation/store/dynamicTranslationSlice';
import { activityTasksApi } from 'features/participations/schedule/store/activityTasksApiSlice';
import { participationDocumentApi } from 'features/participations/store/participationDocumentApiSlice';
import { participationReducer } from 'features/participations/store/participationSlice';
import { activityTaskDocumentApi } from 'features/questionnaires/store/activityTaskDocumentApiSlice';
import { activityTaskReducer } from 'features/questionnaires/store/activityTaskSlice';
import { questionnaireAssetApi } from 'features/questionnaires/store/questionnaireAssetApiSlice';
import { questionnaireReducer } from 'features/questionnaires/store/questionnaireSlice';
import { navigationReducer } from 'features/routing/navigationSlice';
import { systemInfoReducer } from 'features/system-info/store/systemInfoSlice';

export const rootReducer = combineReducers({
  auth: authReducer,
  navigation: navigationReducer,
  devTools: devToolsReducer,
  questionnaire: questionnaireReducer,
  activityTask: activityTaskReducer,
  participation: participationReducer,
  dynamicTranslation: dynamicTranslationReducer,
  adminProtocolEditor: adminProtocolEditorReducer,
  brandDraft: brandDraftReducer,
  adminNotificationTemplates: adminNotificationTemplatesReducer,
  adminDerivedNotifications: adminDerivedNotificationsReducer,
  systemInfo: systemInfoReducer,
  [activityTasksApi.reducerPath]: activityTasksApi.reducer,
  [activityTaskDocumentApi.reducerPath]: activityTaskDocumentApi.reducer,
  [questionnaireAssetApi.reducerPath]: questionnaireAssetApi.reducer,
  [participationDocumentApi.reducerPath]: participationDocumentApi.reducer,
  [adminStudyEditorFullExamplesApi.reducerPath]:
    adminStudyEditorFullExamplesApi.reducer,
  [brandsApi.reducerPath]: brandsApi.reducer,
});
